/**
 * screen接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const screen = {
  // 获取投屏投票进行状态
  getScreenFlow (params) {
    return axios.get('/api/vote/getScreenFlow', { params })
  },
  // 获取投屏投票进行状态
  getShortlistedScreenFlow (params) {
    return axios.get('/api/vote/GetShortlistedScreenFlow', { params })
  },
  /** 大屏幕 **/
  // 获取投屏投票主办方信息
  getScreenVoteSponsorInfo (params) {
    return axios.get('/api/vote/getScreenVoteSponsorInfo', { params })
  },
  // 获取投票项目信息
  getScreenVoteProject (params) {
    return axios.get('/api/vote/getScreenVoteProject', { params })
  },
  // 获取当前投票评分信息
  getScreenVoteJudgeInfo (params) {
    return axios.get('/api/vote/getScreenVoteJudgeInfo', { params })
  },
  // 获取当前投票投票组排名信息
  getGroupRankingInfo (params) {
    return axios.get('/api/vote/getGroupRankingInfo', { params })
  },
  // 获取当前投票结果
  getGroupRankingList (params) {
    return axios.get('/api/vote/GetGroupRankingList', { params })
  },
  // 投屏评选项目分数计算
  getScreenVoteCalculateScoreDetail (params) {
    return axios.get('/api/vote/GetScreenVoteCalculateScoreDetail', { params })
  },
  /** 大屏幕 **/

  /** 主持人 **/

  // 投票主持人--获取投票分组项目列表信息
  getScreenVoteGroupProjects (params) {
    return axios.get('/api/vote/getScreenVoteGroupProjects', { params })
  },
  // 投票主持人--进入颁奖典礼
  chairScreenVoteAwardCeremony (params) {
    return axios.post('/api/vote/chairScreenVoteAwardCeremony', params)
  },
  // 投票主持人--获取投票操作条件信息
  chairScreenVoteOpenProject (params) {
    return axios.post('/api/vote/chairScreenVoteOpenProject', params)
  },
  getChairScreenControlInfo (params) {
    return axios.get('/api/vote/getChairScreenControlInfo', { params })
  },
  // 投票主持人--开始投票
  startChairScreenVote (params) {
    return axios.post('/api/vote/startChairScreenVote', params)
  },
  // 投票主持人--结束投票
  endChairScreenVote (params) {
    return axios.post('/api/vote/endChairScreenVote', params)
  },
  // 投票主持人--投票项目是否取消最高分、最低分
  chairScreenHighestAndLowest (params) {
    return axios.post('/api/vote/chairScreenHighestAndLowest', params)
  },
  // 投票主持人--保存分数的最终结果
  saveProjectScreenScore (params) {
    return axios.post('/api/vote/saveProjectScreenScore', params)
  },
  // 投票主持人--分组排名
  chairScreenGroupRanking (params) {
    return axios.post('/api/vote/chairScreenGroupRanking', params)
  },
  // 投票主持人--获取上一个项目投票操作条件信息
  chairScreenVoteOpenPreviousProject (params) {
    return axios.post('/api/vote/chairScreenVoteOpenPreviousProject', params)
  },
  // 投票主持人--获取下一个项目投票操作条件信息
  chairScreenVoteOpenNextProject (params) {
    return axios.post('/api/vote/chairScreenVoteOpenNextProject', params)
  },
  // 投票主持人--颁奖典礼投屏投票列表
  getAwardCeremonyScreenVoteList (params) {
    return axios.get('/api/vote/GetAwardCeremonyScreenVoteList', { params })
  },
  // 投票主持人--进入颁奖典礼
  openScreenVoteAwardCeremony (params) {
    return axios.post('/api/vote/OpenScreenVoteAwardCeremony', params)
  },
  // 投票主持人--投屏控制
  screenAudioOperate (params) {
    return axios.post('/api/vote/ScreenAudioOperate', params)
  },
  /** 主持人 **/

  /** 投票人 **/
  // 投票人--获取投票人用户信息
  getJudgeVoteUser () {
    return axios.get('/api/vote/getJudgeVoteUser')
  },
  // 投票人--获取投票项目信息
  getJudgeVoteProject (params) {
    return axios.get('/api/vote/getJudgeVoteProject', { params })
  },
  // 投票人--获取当前项目的分数
  getProjectScore (params) {
    return axios.get('/api/vote/getProjectScore', { params })
  },
  // 投票人--保存打分分数
  setProjectScore (params) {
    return axios.post('/api/vote/setProjectScore', params)
  },
  /** 投票人 **/
  // 投票人--保存打分分数
  exportVoteScreenResult (params) {
    return axios({
      method: 'post',
      url: '/api/vote/ExportVoteScreenResult',
      data: params,
      responseType: 'blob'
    })
  }
}

export default screen
